module.exports = __webpack_public_path__ + "img/tips_1.08379712.png";